import React, {Component} from 'react'
import ResultPage from '../ResultPage/ResultPage'
import styles from '../StartPage/startPage.module.scss'
import style from './questions.module.scss'
import {v1 as uuidv1} from 'uuid'

const title = styles.startPage__title + ' ' + style.questions__title
const btn = styles.startPage__btn + ' ' + style.questions__btn

class Questions extends Component {
   render() {
      const {questions} = this.props
      const {question, name_param_question, answers, count_question, count_answer} = questions
      return (
         <>
            {question
               ?
               <div className={style.questions} name={name_param_question}>
                  <div className={style.questions__numBlock}>
                     <div className={style.questions__num}> {count_answer}/{count_question} </div>
                  </div>
                  <h1 className={title}>{question}</h1>
                  {/* <p className={style.questions__subtitle}>* To see if you qualify, please answer these simple questions:</p> */}
                  <ul className={style.questions__btnList}>
                     {answers.map(({answer_value, answer_text}, idx) => (
                        <li className={style.questions__btnItem} key={idx}>
                           <button className={btn} onMouseDown={this.props.onMouseDown} onMouseUp={this.props.onMouseUp}
                                   key={uuidv1()} value={answer_value}>{answer_text}
                              <svg className={style.questions__btnArrow} width='8' height='13'
                                   viewBox='0 0 8 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                 <path d='M1.25 11.75L6.5 6.5L1.25 1.25' stroke='#EF4644' strokeWidth='2' />
                              </svg>
                           </button>
                        </li>
                     ))}
                  </ul>
               </div>
               :
               <ResultPage final={questions} />
            }
         </>
      )
   }
}

export default Questions